import { motion } from "framer-motion";
import { IdentificationBadge, ShieldCheck, Wrench, GraduationCap, HandHeart } from "@phosphor-icons/react";

const STEPS = [
  {
    Icon: IdentificationBadge,
    title: "Identity Check",
    desc: "Every candidate submits valid ID and address proof — no shortcuts, everything on record.",
  },
  {
    Icon: ShieldCheck,
    title: "Background Screening",
    desc: "Detailed background verification for safety and trust before anyone joins your home.",
  },
  {
    Icon: Wrench,
    title: "Skill Assessment",
    desc: "We evaluate cooking, cleaning, childcare and daily-home-flow ability — real skills, not claims.",
  },
  {
    Icon: GraduationCap,
    title: "Professional Training",
    desc: "Shortlisted staff go through hands-on training so service quality stays consistent.",
  },
  {
    Icon: HandHeart,
    title: "Client Matching",
    desc: "We match each maid to your family's lifestyle, language and schedule for a smooth fit.",
  },
];

export default function Process() {
  return (
    <section id="process" className="py-24 md:py-32 bg-white" data-testid="process">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="max-w-2xl mb-14">
          <p className="label-caps text-[var(--gold)] mb-4">Our Process</p>
          <h2 className="font-display text-4xl md:text-6xl text-[var(--navy)] tracking-tighter leading-[1.02]">
            How we hire the maids we send home.
          </h2>
          <p className="mt-5 text-slate-600 leading-relaxed">
            A careful 5-step process — transparent, verified, stress-free.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-5">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.55, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className="relative rounded-3xl border border-slate-200 bg-white p-6 hover:shadow-xl hover:-translate-y-1 transition-[transform,box-shadow] duration-300"
              data-testid={`process-step-${i + 1}`}
            >
              <div className="absolute -top-3 left-6 rounded-full bg-[var(--gold)] text-[var(--navy)] text-xs font-bold px-3 py-1 tracking-wider">
                STEP {String(i + 1).padStart(2, "0")}
              </div>
              <span className="mt-2 grid place-items-center h-12 w-12 rounded-2xl bg-[var(--navy)]/8 text-[var(--navy)]">
                <s.Icon weight="duotone" size={26} />
              </span>
              <h3 className="font-display text-xl text-[var(--navy)] mt-5 tracking-tight">
                {s.title}
              </h3>
              <p className="text-sm text-slate-600 mt-2 leading-relaxed">{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
